import { render, staticRenderFns } from "./dropdownmenu.vue?vue&type=template&id=15f69815&scoped=true&"
import script from "./dropdownmenu.vue?vue&type=script&lang=js&"
export * from "./dropdownmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f69815",
  null
  
)

export default component.exports